
        import * as module0 from '$components/shared/site_header.js'
        const modules = {
            "shared/site_header.js": module0,
        };
        export default modules;
      